import InvoiceForm from '../components/InvoiceForm';

const NewInvoice = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold mb-8">Create New Invoice</h1>
      <InvoiceForm />
    </div>
  );
};

export default NewInvoice; 